import * as React from 'react';
import clx from 'classnames';
import { Row } from 'antd';
import './PageFullRow.scss';
import { RowProps } from 'antd/lib/row';

export interface FullPageRowProps extends RowProps {}

/**
 * Continitore principale della pagina frontend stilizzata
 */
export function PageFullRow(props: FullPageRowProps) {
  const { gutter, className, ...othersProps } = props;

  return (
    <Row
      gutter={16}
      className={clx('page-full-row', className)}
      {...othersProps}
    />
  );
}
